import { setupFormState } from '@/components/form/tidal-form'
import { FormValues } from '../../../types'

export const initialValues: FormValues = {
  name: '',
}

export const form = setupFormState<FormValues>({
  id: 'companies-add-form',
  initialValues,
})
